import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "motion/react";
import "./slideshow.css";

interface SlideshowProps {
  images: string[];
  captions: string[];
  interval?: number;
}
export default function Slideshow({
  images,
  captions,
}: SlideshowProps) {
  const [index, setIndex] = useState(0);

   useEffect(() => {
    images.forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }, [images]);

  const next = () =>
    setIndex((prev) => (prev + 1) % images.length);

  const prev = () =>
    setIndex((prev) => (prev - 1 + images.length) % images.length);

  return (
    <div className="slideshow">
      <AnimatePresence mode="wait">
        <motion.img
          key={index}
          src={images[index]}
          className="slideshow-image"
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: -50 }}
          transition={{ duration: 0.5 }}
        />
      </AnimatePresence>

      <AnimatePresence mode="wait">
        <motion.div
          key={captions[index]}
          className="caption"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.3 }}
        >
          {captions[index]}
        </motion.div>
      </AnimatePresence>

      <button onClick={prev} className="prev">
        ◀
      </button>

      <button onClick={next} className="next">
        ▶
      </button>
    </div>
  );
}